(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["flatten-boolean-op"] = factory();
	else
		root["flatten-boolean-op"] = factory();
})(window, function() {
return 